import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AlertCircle, Save } from 'react-feather';
import config from '../../../../config';
import ModalShell from '../shared/ModalShell';

/**
 * Add / Edit modal for the Category entity.
 */
const CategoryFormModal = ({ mode = 'add', entityId, onClose, onSaved }) => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(mode === 'edit');

    const concessionaireId = localStorage.getItem('concessionaireId');
    const loginId = localStorage.getItem('loginId');
    const token = localStorage.getItem('sessiontoken');
    const headers = { Authorization: `${token}` };

    useEffect(() => {
        if (mode !== 'edit' || !entityId) return;
        let cancelled = false;
        setLoading(true);
        axios
            .get(`${config.hostname}/category/${entityId}`, { headers })
            .then((res) => { if (!cancelled) setName(res.data.category_name || ''); })
            .catch((err) => {
                console.error(err);
                toast.error(t('Failed to load category'));
                onClose?.();
            })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [mode, entityId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setErrors({ name: t('Category name is required') });
            return;
        }
        setSaving(true);
        const payload = {
            category_name: name,
            category_concessionaire_id: concessionaireId,
            login_id: loginId,
        };
        const req = mode === 'add'
            ? axios.post(`${config.hostname}/category`, payload, { headers })
            : axios.post(`${config.hostname}/category/updatecategory/${entityId}`, payload, { headers });
        req
            .then(() => {
                toast.success(mode === 'add' ? t('Category added') : t('Category updated'));
                onSaved?.();
                onClose?.();
            })
            .catch((err) => {
                console.error(err);
                toast.error(t('Save failed'));
            })
            .finally(() => setSaving(false));
    };

    return (
        <ModalShell title={mode === 'add' ? t('Add category') : t('Edit category')} onClose={onClose} maxWidth={480}>
            {loading ? (
                <div className="v3-sadmin-empty"><p>{t('Loading…')}</p></div>
            ) : (
                <form className="v3-sadmin-form" onSubmit={handleSubmit}>
                    <label className="v3-field">
                        <span className="v3-label">{t('Category name')}</span>
                        <input
                            className="v3-input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder={t('Fashion, F&B, Electronics…')}
                            autoFocus
                        />
                        {errors.name && (
                            <span className="v3-sadmin-field-err"><AlertCircle size={12} />{errors.name}</span>
                        )}
                    </label>
                    <div className="v3-sadmin-form-actions">
                        <button type="button" className="v3-btn v3-btn-ghost" onClick={onClose} disabled={saving}>
                            {t('Cancel')}
                        </button>
                        <button type="submit" className="v3-btn v3-btn-primary" disabled={saving}>
                            <Save size={14} /> {saving ? t('Saving…') : mode === 'add' ? t('Add category') : t('Save changes')}
                        </button>
                    </div>
                </form>
            )}
        </ModalShell>
    );
};

export default CategoryFormModal;
